import { AiBrand, AnswerCardType } from '../constants';
import type { commonAttributesType } from './types';

/**
 * The default `commonAttributes` used when there is no `AIAnswerContext`
 * provider. Exported from its own module so hosts that render AI-answer
 * components outside the answer dialog (e.g. the FPS results list) can build a
 * complete attributes object from it without depending on the context module.
 */
export const UNINITIALIZED_COMMON_ATTRIBUTES: commonAttributesType = {
	cloudId: '',
	query: '',
	queryHash: '',
	baseQueryHash: '',
	source: '',
	searchSessionId: '',
	answerString: '',
	answerLength: 0,
	answerWordCount: 0,
	answerFormat: null,
	answerCardType: AnswerCardType.SAIN,
	sources: [],
	followUps: [],
	errorStateSuggestedQueries: [],
	errorState: null,
	extraAttributes: {},
	apiSource: 'cc-search-nlp',
	workspaceId: '',
	sessionId: '',
	brand: AiBrand.AI,
	orgId: '',
	isHello: false,
};
